// extracted by mini-css-extract-plugin
module.exports = {"root":"SubjectCard_root__p4AYe","imageWrapper":"SubjectCard_imageWrapper__KZKRL","title":"SubjectCard_title__MdkDZ","description":"SubjectCard_description__cHn3c"};